import requireModule from 'src/require-module'

require("src/load-globals");
require("services/websocket-queue");

requireModule('user/home');
requireModule('user/account_settings');
requireModule('user/profile');
requireModule('user/certificate/detail');
requireModule('user/registration');

requireModule('user/portfolio/builder');
requireModule('user/portfolio/detail');

requireModule('common/coursework/gallery/overview');
requireModule('common/coursework/gallery/detail');

requireModule('common/messenger');

requireModule('common/calendar');

requireModule('common/shop/plans');
requireModule('common/shop/card_service');

requireModule('common/top_nav');

requireModule('common/error/show');

requireModule('user/enrollment_info');

requireModule('common/course/my_courses');
requireModule('common/site_alert');
requireModule('common/parallax');

requireModule('common/course/list');
requireModule('common/parallax');
requireModule('common/course/syllabus');
requireModule('common/course/block_syllabus');
requireModule('common/course/type');
requireModule('common/course/welcome');
requireModule('common/course/review');
requireModule('common/program/review');

requireModule('user/confirmation_required');
requireModule('user/course_export/listing');

requireModule('user/notification/listing');

requireModule('common/notification_center');

requireModule('instructor/course/create_actions');
requireModule('instructor/course/selector');
requireModule('instructor/course/import');

requireModule('kadenze_public/hero/video');

requireModule('user/referrals');
requireModule('common/search/results');

requireModule('common/placeholder');
